import module from 'recursoshumanos/module.js'
import * as moment from 'moment'

const schema = {
  duracion: 'number',
  fecha_final: 'date',
  fecha_inicial: 'date',
  id: 'number',
  indice: 'number',
}

export class RecursoshumanosReportesIncapacidadesService {
  constructor ($http) {
    this.$http = $http
  }

  get (idEmpresa, fechaInicial, fechaFinal, formato) {
    return this.$http.get('/api/recursos_humanos/reportes/incapacidades', {
      params: {
        id_empresa: idEmpresa,
        fecha_inicial: moment(fechaInicial).format('YYYY-MM-DD'),
        fecha_final: moment(fechaFinal).format('YYYY-MM-DD'),
        formato: formato,
      },
      schema,
      download: formato === 'xls',
    })
  }
}

module.service('RecursoshumanosReportesIncapacidadesService', RecursoshumanosReportesIncapacidadesService)



// WEBPACK FOOTER //
// ./src/recursoshumanos/services/RecursosHumanos/Reportes/Incapacidades.js